import { isEntityListConfiguration } from '../../screens/Configuration/ConfigurationCategories/SegmentPotentialDefinition/segmentPotentialDefinitionLib';
import { CategoryFieldConfigurationResponse, SkuType } from '@ydistri/api-sdk';
import {
  BaseRootConfiguration,
  CategoryConfigurationData,
} from '../../hooks/useCategoryConfiguration';
import { getValidSkuType } from './getValidSkuType';

export const parseRootCategoryConfiguration = (
  rootCategoryConfiguration: CategoryFieldConfigurationResponse[] | undefined,
): BaseRootConfiguration => {
  const base: Partial<CategoryConfigurationData['rootCategoryConfiguration']> = {};

  if (rootCategoryConfiguration) {
    rootCategoryConfiguration.forEach(field => {
      const value = field.value;
      const fieldType = field.fieldType;
      const skuType = getValidSkuType(field.skuType);

      if (!base[fieldType]) {
        let defaultValue = '0';

        if (isEntityListConfiguration(fieldType)) {
          defaultValue = '[]';
        }

        base[fieldType] = {
          [SkuType.DeadStock]: defaultValue,
          [SkuType.SlowMover]: defaultValue,
          [SkuType.FastMover]: defaultValue,
        };
      }

      base[fieldType][skuType] = value;
    });
  }

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- not sure why is it like this
  return base as BaseRootConfiguration;
};
